import React from 'react';
import { Card } from '../../../components/ui/Card';
import { Button } from '../../../components/ui/Button';
import { TabNavigation } from '../../../components/operations/TabNavigation';
import { OperationsSwitcher } from '../../../components/operations/OperationsSwitcher';
const LOCATION_TABS = [{
  label: 'Overview',
  path: ''
}, {
  label: 'Capacity',
  path: 'capacity'
}, {
  label: 'Performance',
  path: 'performance'
}, {
  label: 'Costs',
  path: 'costs'
}, {
  label: 'Settings',
  path: 'settings'
}];
export function Settings() {
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-1984">
      <h1 className="text-2xl font-bold text-text-primary" data-id="element-1985">
        Location Settings
      </h1>

      <OperationsSwitcher data-id="element-1986" />

      <TabNavigation tabs={LOCATION_TABS} basePath="/operations/locations" data-id="element-1987" />

      <div className="max-w-2xl space-y-6" data-id="element-1988">
        <Card data-id="element-1989">
          <h3 className="font-bold mb-4" data-id="element-1990">General Information</h3>
          <div className="space-y-4" data-id="element-1991">
            <div data-id="element-1992">
              <label className="block text-sm text-text-secondary mb-1" data-id="element-1993">
                Location Name
              </label>
              <input type="text" defaultValue="Vračar" className="w-full bg-background border border-white/10 rounded-lg p-2 text-sm" data-id="element-1994" />
            </div>
            <div data-id="element-1995">
              <label className="block text-sm text-text-secondary mb-1" data-id="element-1996">
                Address
              </label>
              <input type="text" defaultValue="Njegoševa 42, Belgrade" className="w-full bg-background border border-white/10 rounded-lg p-2 text-sm" data-id="element-1997" />
            </div>
            <div data-id="element-1998">
              <label className="block text-sm text-text-secondary mb-1" data-id="element-1999">
                Phone
              </label>
              <input type="text" defaultValue="+381 11 123 4567" className="w-full bg-background border border-white/10 rounded-lg p-2 text-sm" data-id="element-2000" />
            </div>
          </div>
        </Card>

        <Card data-id="element-2001">
          <h3 className="font-bold mb-4" data-id="element-2002">Operating Hours</h3>
          <div className="space-y-3" data-id="element-2003">
            {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map(day => <div key={day} className="flex items-center justify-between" data-id="element-2004">
                <span className="text-sm w-24" data-id="element-2005">{day}</span>
                <div className="flex items-center gap-2" data-id="element-2006">
                  <input type="time" defaultValue="10:00" className="bg-background border border-white/10 rounded p-1 text-sm" data-id="element-2007" />
                  <span data-id="element-2008">-</span>
                  <input type="time" defaultValue="23:00" className="bg-background border border-white/10 rounded p-1 text-sm" data-id="element-2009" />
                </div>
              </div>)}
          </div>
        </Card>

        <div className="flex justify-end gap-3" data-id="element-2010">
          <Button variant="secondary" data-id="element-2011">Cancel</Button>
          <Button data-id="element-2012">Save Changes</Button>
        </div>
      </div>
    </div>;
}